import { render, staticRenderFns } from "./v-sidebar-item.vue?vue&type=template&id=d909e7fc&scoped=true&"
import script from "./v-sidebar-item.vue?vue&type=script&lang=js&"
export * from "./v-sidebar-item.vue?vue&type=script&lang=js&"
import style0 from "./v-sidebar-item.vue?vue&type=style&index=0&id=d909e7fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d909e7fc",
  null
  
)

export default component.exports